import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  gsap.set(".footer-container span", { opacity: 0, x: -100 });
  gsap.set(".footer-container img", { opacity: 0, x: 100 });

  gsap.to(".footer-container span", {
    x: 0, // Moves to the original position
    duration: 1,
    opacity: 1,
    ease: "power3.inout",
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".footer", // The element that triggers the animation
      start: "top bottom-=10%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".footer-container img", {
    x: 0, // Moves to the original position
    duration: 1,
    opacity: 1,
    ease: "power3.inout",
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".footer", // The element that triggers the animation
      start: "top bottom-=10%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
    onComplete: function () {
      gsap.set(".footer-container img", { clearProps: "all" }); // Removes inline styles so CSS animations work again
    },
  });
});
